import {Component, OnDestroy} from '@angular/core';
import {Subject} from 'rxjs';
import {
    MxFormCustomizerEvent, MxFormErrorMessageService,
    OnBoFormReady
} from 'mx-core';
import { PrlTranslateService } from '../../../../shared/services/prl-translate.service';
import {FormGroup} from '@angular/forms';
import {Router} from '@angular/router';
import {PrlProfilesDataService} from '../../services/prl-profiles-data.service';

@Component({
    selector: 'prl-profile-edit',
    template: `<mx-object-form (customize)="onCustomize($event)"></mx-object-form>`,
    standalone: false
})
export class PrlProfileEditComponent implements OnDestroy, OnBoFormReady {

    private _destroy$$: Subject<null> = new Subject<null>();
    private form: FormGroup;

    constructor(
        private router: Router,
        private translateService: PrlTranslateService,
        private prlProfilesCampaignDataService: PrlProfilesDataService,
        private errorService: MxFormErrorMessageService,

    ) {}


    onCustomize(event: MxFormCustomizerEvent): void {
        event.customizeProps({addPrefixToTitle: false})
             .customizeBoFormConfig({title: this.translateService.getTranslatedLabel('label.profiles.view.edit.profile')})

        event.addCustomizer(this);
    }


    boOnFormReady(form: FormGroup): void {
        form.setAsyncValidators(this.errorService.asyncValidator(this.prlProfilesCampaignDataService));
        this.form = form;
    }


    ngOnDestroy(): void {
        this._destroy$$.next(null);
    }


}
